/**
 * Role-aware navigation helpers.
 */
export function roleHomePath(role) {
    switch (role) {
        case "admin":
            return "/admin";
        case "staff":
            return "/staff";
        case "kitchen":
            return "/kitchen";
        default:
            return "/";
    }
}

export function isStaffRole(role) {
    return role === "staff" || role === "admin";
}

export function isKitchenRole(role) {
    return role === "kitchen" || role === "admin";
}

export function isAdminRole(role) {
    return role === "admin";
}
